/*
 * Create table columns containing:
 * - answer dates as a value
 * - and assignmentId as a key
 */
/* eslint-disable */
import moment from 'moment-timezone';

const DATE_FORMAT = 'MMM DD';
const removeMS = date => date.substr(0, date.indexOf('.'));

export default (assignments, triggeredDaysMap) => {
  const defaultColumn = { '': '' };

  if (!assignments) return {};

  return assignments.reduce((columns, assignment) => {
    const {
      answers,
      assignmentId,
      sentAt,
      localCompletedAt,
      completedAtTimezone,
    } = assignment;

    const dateKey = moment(localCompletedAt)
      .tz(completedAtTimezone)
      .format(DATE_FORMAT);
    const answerDate = removeMS(sentAt);

    triggeredDaysMap[assignmentId] = answers.some(answer => answer.triggered)
      ? answerDate
      : false;

    columns[assignmentId] = {
      value: dateKey,
      triggered: triggeredDaysMap[assignmentId],
      answerDate,
    };

    return columns;
  }, defaultColumn);
};



// WEBPACK FOOTER //
// ./src/components/Survey/helpers/getColumns.js